import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mock';
import Logo from './Logo';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Visa Services', href: '/services' },
    { name: 'New Zealand Visas', href: '/new-zealand-visas' },
    { name: 'Eligibility Check', href: '/eligibility' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      {/* Top Info Bar */}
      <div className="bg-gradient-to-r from-blue-600 to-teal-600 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center sm:justify-between items-center gap-2 text-sm">
            <div className="flex items-center gap-4">
              <a href={`tel:${contactInfo.phones.india1}`} className="flex items-center gap-1 hover:text-blue-100 transition-colors">
                <Phone className="h-3 w-3" />
                <span className="hidden sm:inline">{contactInfo.phones.india1}</span>
              </a>
              <a href={`tel:${contactInfo.phones.newZealand}`} className="flex items-center gap-1 hover:text-blue-100 transition-colors">
                <Phone className="h-3 w-3" />
                <span className="hidden sm:inline">{contactInfo.phones.newZealand}</span>
              </a>
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-1 hover:text-blue-100 transition-colors">
                <Mail className="h-3 w-3" />
                <span className="hidden md:inline">{contactInfo.email}</span>
              </a>
            </div>
            <div className="text-xs sm:text-sm font-medium">
              New Zealand Visa Specialists
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-36">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <Logo size="default" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-700 hover:text-blue-600 font-medium text-sm transition-colors relative group"
              >
                {item.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button asChild className="bg-gradient-to-r from-blue-600 to-teal-600 hover:from-blue-700 hover:to-teal-700 text-white shadow-md hover:shadow-lg transition-all">
              <Link to="/eligibility">Check Eligibility</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 animate-in slide-in-from-top-5">
            <div className="flex flex-col gap-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors font-medium"
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/eligibility"
                onClick={() => setMobileMenuOpen(false)}
                className="mx-4 mt-2"
              >
                <Button className="w-full bg-gradient-to-r from-blue-600 to-teal-600 text-white">
                  Check Eligibility
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
